'use strict'

TEN_YEARS_IN_SECONDS = 60 * 60 * 24 * 365 * 10

###*
# Wrapper to set or unset cookies
#
# @public                     Groupon.Utils.setSiteCookies
#
# @param {Object} cookies   - Key/value pairs of cookie name and value. When the value is null, the cookie will be unset.
# @param {Number} [seconds] - Time to live (Optional)
###
module.exports = setSiteCookies = (cookies, seconds = TEN_YEARS_IN_SECONDS) ->
  cookieDomain = setSiteCookies.cookieDomain ||= $('head').data 'domain'
  for key, val of cookies
    if val?
      Cookie.set key, val, seconds, cookieDomain
    else
      Cookie.unset key, cookieDomain



// WEBPACK FOOTER //
// ./src/frontend/helper/general/m_setSiteCookies.coffee